import React from "react";
import { Box, Typography, IconButton, Paper, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import person from "../../../assets/images/SVG/person.svg"
import * as routes from "../../../constants/routes";

const UsersCard = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { session } = useSelector((state) => state.session);

    const usersCount = session?.my_user?.count_patient ?? 0;
    const invitesCount = session?.permissions?.users ?? 0;
    const invitesRemaining = invitesCount - usersCount;

    const usersLabel = usersCount <= 1 ? t("global.my_user") : t("global.my_users");
    const invitesLabel = invitesRemaining <= 1 ? t("global.remaining_invite") : t("global.remaining_invites");

    const handleClick = () => {
        navigate(routes.R_LIST_MY_USERS);
    }

    return (
        <Paper
            elevation={0}
            onClick={handleClick}
            sx={{
                borderRadius: "6",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                height: "100%",
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "#ede3f5",
                    border: "3px solid #662D91",
                    padding: "17px"
                }
            }}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Box sx={{
                    backgroundColor: "#ede3f5",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "60px",
                    height: "60px",
                }}>
                    <img src={person} alt="Usuarios" width="100%" height="100%" />
                </Box>
                <IconButton size="small" sx={{ color: "#333333", padding: "4px" }}>
                    <ArrowForwardIcon fontSize="small" />
                </IconButton>
            </Stack>

            <Stack spacing={0.5}>
                {usersCount === 0 ? (
                    <>
                        <Typography fontFamily="Montserrat" fontWeight={700} fontSize="15px" color="#333333">
                            {t("newActivities.invite_users")}
                        </Typography>
                        <Typography fontFamily="Montserrat" fontWeight={400} fontSize="15px" color="text.secondary">
                            {t("global.send_first_invite")}
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography fontFamily="Montserrat" fontWeight={700} fontSize="15px" color="#333333">
                            {usersLabel}: {usersCount}
                        </Typography>
                        <Typography fontFamily="Montserrat" fontWeight={400} fontSize="15px" color="text.secondary">
                            {invitesLabel}: {invitesRemaining}
                        </Typography>
                    </>
                )}
            </Stack>
        </Paper>
    )
}

export default UsersCard;